const FALLBACK_LANG = "en";

const translateObject = (object, language, fallback = true) => {
  if (object) {
    if (language) {
      if (object.hasOwnProperty(language)) {
        return object[language];
      } else if (object.hasOwnProperty(FALLBACK_LANG)) {
        if (fallback) {
          return object[FALLBACK_LANG];
        }
        return null;
      }
    }

    return object;
  }

  return null;
};

export default translateObject;
